@if (isMenu) {
  @if (showButton) {
    <button mat-menu-item [attr.aria-label]="'forwardAsText' | translate">
      <div class="item-menu-center">
       <span class="material-symbols-outlined -scale-x-100">
          reply
       </span>
        {{ 'forwardAsText' | translate }}
      </div>
    </button>
  }
} @else {
  <app-loading-icon-button
    label="forwardAsText"
    icon="reply"
    classIcon="material-symbols-outlined -scale-x-100"
    [showButton]="showButton"
    [disabled]="disabled"
    [showLoading]="showLoading"
  ></app-loading-icon-button>
}
